import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import FileUploader from './FileUploader'
import ReadyFile, { ReadyFileParams } from './FileUploader/File/UploadedFile'
import { UploadFile } from './FileUploader/File/File'

type ExpandedElement = Element&{ files: File[], deletedIds: number[] }

export default function FileUploaderPortal() {
  const [fileUploaderElements, setFileUploaderElements] = useState<Element[]>([])

  useEffect(() => {
    setFileUploaderElements(Array.from(document.querySelectorAll('.file_uploader')))
  }, [])

  const onFilesAdded = (element: ExpandedElement) => (files: File[]) => {
    // eslint-disable-next-line no-param-reassign
    element.files = [...(element.files || []), ...files];
  }

  const OnDelete = (element: ExpandedElement) => (file: UploadFile) => {
    if (file.type === 'client') {
      // eslint-disable-next-line no-param-reassign
      element.files = element.files.filter(f => f !== file.file)
    } else if (file.type === 'ready') {
      // eslint-disable-next-line no-param-reassign
      element.deletedIds = [...(element.deletedIds || []), file.id]
    } else {
      throw new Error('No implementation for type file type')
    }
  }

  return (<>
    {fileUploaderElements.map((element) => {
      const maxSizeInMB = element.getAttribute('data-maxSizeInMB')
      const formats = element.getAttribute('data-formats')
      return createPortal(<FileUploader
        onFilesAdded={onFilesAdded(element as unknown as ExpandedElement)}
        onDelete={OnDelete(element as unknown as ExpandedElement)}
        initialFiles={(JSON.parse(element.getAttribute('data-initialFiles') || '[]') as ReadyFileParams[]).map(file => ReadyFile(file))}
        multiple={element.getAttribute('data-oneFile') === null}
        accept={element.getAttribute('data-accept')}
        maxSizeInMB={maxSizeInMB ? parseInt(maxSizeInMB, 10) : null}
        formats={formats ? formats.split(',') : []}
      />, element)
    })}
  </>)
}
